import ViewFilter, {
    SortOrder,
} from "@/domain/entities/customViews/ViewFilter";
import {
    CustomViewSortOrder,
    ViewFilter as ViewFilterSDK,
} from "@cs_teamwaydev/mailvista-sdk_react";

export const viewFilterToDomainMapper = (
    viewFilter: ViewFilterSDK,
): ViewFilter =>
    new ViewFilter({
        keywords: viewFilter.keywords,
        startDate: viewFilter.startDate
            ? new Date(viewFilter.startDate)
            : undefined,
        endDate: viewFilter.endDate ? new Date(viewFilter.endDate) : undefined,
        identifiedSendersEmails: viewFilter.identifiedSenders,
        identifiedRecipientsEmails: viewFilter.identifiedRecipients,
        sortOrder:
            viewFilter.sortOrder as any as SortOrder /* SortOrder| undefined */,
    });

export const viewFilterToSDKMapper = (
    viewFilter: ViewFilter,
): ViewFilterSDK => ({
    keywords: viewFilter.keywords ?? [],
    startDate: viewFilter.startDate?.toISOString() ?? null,
    endDate: viewFilter.endDate?.toISOString() ?? null,
    identifiedSenders: viewFilter.identifiedSendersEmails ?? [],
    identifiedRecipients: viewFilter.identifiedRecipientsEmails ?? [],
    sortOrder: viewFilter.sortOrder as any as CustomViewSortOrder,
});
